export const BUSINESS_PHONE_TEL = '+19259975853';
export const BUSINESS_NAME = 'Greetings by the Yard';
